module.exports = __webpack_public_path__ + "static/media/bowen-47.dfd645a0.jpg";